import { createContext, useContext, type ReactNode } from "react";
import type { MeUser } from "../lib/fetch-me";

const Ctx = createContext<MeUser | null>(null);

/** Present only under the signed-in dispensary ops shell (workspace layout). */
export function WorkspaceMeProvider({ user, children }: { user: MeUser; children: ReactNode }) {
  return <Ctx.Provider value={user}>{children}</Ctx.Provider>;
}

export function useWorkspaceMe(): MeUser | null {
  return useContext(Ctx);
}
